import { render, staticRenderFns } from "./comAddrList.vue?vue&type=template&id=e2eea66c&scoped=true&"
import script from "./comAddrList.vue?vue&type=script&lang=js&"
export * from "./comAddrList.vue?vue&type=script&lang=js&"
import style0 from "./comAddrList.vue?vue&type=style&index=0&id=e2eea66c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2eea66c",
  null
  
)

export default component.exports